import React from "react";
import "./aboutUsSection.css";
// import aboutImg from "../../../../assets/about_us_illustration.png"; // Use a relevant image here
import aboutImg from "../../../../assets/about_us_image.jpg";
function AboutUsSection() {
  return (
    <section id="about" className="about-us">
      <div className="about-content">
        <h2>
          Why <span>MediQNow</span>?
        </h2>
        <p className="subtitle">
          We believe healthcare should be fast, reliable, and at your fingertips.
        </p>
        <p className="description">
          MediQNow is your go-to platform for accessing hospitals, clinics, labs, and medical shops — all in one place. 
          Whether you're booking an appointment, checking lab results, or ordering medicines from your nearby pharmacy, 
          MediQNow brings healthcare closer to your life, not the other way around.
        </p>
        <ul className="about-points">
          <li>✔ Seamless appointment scheduling with verified doctors</li>
          <li>✔ One-tap access to test reports and lab bookings</li>
          <li>✔ Trusted local pharmacies for quick delivery</li>
          <li>✔ Live updates, reminders, and digital health records</li>
        </ul>
      </div>
      <div className="about-image">
        <img src={aboutImg} alt="About MediQNow" />
      </div>
    </section>
  );
}

export default AboutUsSection;